import { useState } from "react";

export default function ExportPanel({ css, onClose }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(css);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleDownload = () => {
    const blob = new Blob([css], { type: "text/css" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "animation.css";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-8"
      onClick={onClose}
    >
      <div
        className="bg-[#0F0F0F] border border-[#145A43] rounded-lg w-full max-w-2xl max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#145A43]/40">
          <h3 className="text-[#D7C7A1] text-sm font-medium">Export CSS</h3>
          <button
            onClick={onClose}
            className="text-[#D7C7A1]/60 hover:text-[#D7C7A1] text-sm"
          >
            ✕
          </button>
        </div>
        <pre className="flex-1 overflow-auto p-4 text-xs text-[#D7C7A1] font-mono whitespace-pre-wrap">
          {css}
        </pre>
        <div className="flex gap-2 px-4 py-3 border-t border-[#145A43]/40">
          <button
            onClick={handleCopy}
            className="flex-1 text-xs py-2 rounded bg-[#145A43] text-[#D7C7A1] hover:bg-[#2F8F6F] transition-colors"
          >
            {copied ? "Tersalin ✓" : "Copy"}
          </button>
          <button
            onClick={handleDownload}
            className="flex-1 text-xs py-2 rounded bg-[#2F8F6F] text-[#0F0F0F] font-medium hover:bg-[#3aa87f] transition-colors"
          >
            Download .css
          </button>
        </div>
      </div>
    </div>
  );
}
